import React, { useMemo, useState } from 'react';
import Checkbox from '../../../../shared/components/Checkbox/Checkbox';
import Chip from '../../../../shared/components/Chip/Chip';
import EmptyState from '../../../../shared/components/EmptyState/EmptyState';
import SearchInput from '../../../../shared/components/SearchInput/SearchInput';
import Typography from '../../../../shared/components/Typography/Typography';
import { parseIdList } from '../wiki.constants';

function WikiRelatedArticleSelector({
  articles = [],
  currentArticleId,
  getCategoryLabel,
  onChange,
  value = '',
}) {
  const [search, setSearch] = useState('');
  const selectedIds = useMemo(() => new Set(parseIdList(value)), [value]);
  const selectedArticles = useMemo(() => articles.filter((article) => selectedIds.has(article.id)), [articles, selectedIds]);

  const filteredArticles = useMemo(() => {
    const needle = search.trim().toLowerCase();
    return articles
      .filter((article) => article.id !== currentArticleId)
      .filter((article) => {
        if (!needle) {
          return true;
        }

        return [
          article.title,
          article.summary,
          article.type,
          getCategoryLabel?.(article.category),
        ].some((part) => String(part || '').toLowerCase().includes(needle));
      })
      .slice(0, 20);
  }, [articles, currentArticleId, getCategoryLabel, search]);

  const toggleArticle = (articleId) => {
    const nextIds = new Set(selectedIds);
    if (nextIds.has(articleId)) {
      nextIds.delete(articleId);
    } else {
      nextIds.add(articleId);
    }
    onChange([...nextIds].join(', '));
  };

  return (
    <div className="wiki-related-selector">
      <SearchInput
        fullWidth
        label="Rechercher un article"
        value={search}
        onChange={(event) => setSearch(event.target.value)}
        placeholder="Titre, catégorie, type..."
      />
      {selectedArticles.length > 0 && (
        <div className="wiki-related-selected" aria-label="Articles selectionnés">
          {selectedArticles.map((article) => (
            <Chip key={article.id} size="small" variant="info">{article.title}</Chip>
          ))}
        </div>
      )}
      <div className="wiki-related-selector-list">
        {filteredArticles.map((article) => (
          <div key={article.id} className="wiki-related-selector-row">
            <Checkbox
              checked={selectedIds.has(article.id)}
              aria-label={`Lier ${article.title}`}
              onChange={() => toggleArticle(article.id)}
            />
            <span>
              <Typography variant="body2">{article.title}</Typography>
              <small>{getCategoryLabel?.(article.category)} - {article.type} - {article.status}</small>
            </span>
          </div>
        ))}
        {!filteredArticles.length && (
          <EmptyState title="Aucun article disponible">
            Les articles publiés ou brouillons chargés dans le Wiki apparaitront ici.
          </EmptyState>
        )}
      </div>
    </div>
  );
}

export default WikiRelatedArticleSelector;
